export const PRIVATE_OR_NOT_FOUND = 'PRIVATE_OR_NOT_FOUND';

function extractErrorMessage(error: unknown): string {
    if (!error) {
        return '';
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error instanceof Error) {
        return error.message || '';
    }

    if (typeof error === 'object' && 'message' in error) {
        const message = (error as { message?: unknown }).message;
        return typeof message === 'string' ? message : '';
    }

    return '';
}

function extractErrorCode(error: unknown): string {
    if (!error || typeof error !== 'object' || !('code' in error)) {
        return '';
    }

    const code = (error as { code?: unknown }).code;
    return typeof code === 'string' ? code : '';
}

export function isPrivateOrNotFoundError(error: unknown): boolean {
    const code = extractErrorCode(error);
    if (code === 'PGRST116' || code === '42501') {
        return true;
    }

    const message = extractErrorMessage(error);
    if (!message) {
        return false;
    }

    if (message === PRIVATE_OR_NOT_FOUND) {
        return true;
    }

    return (
        /multiple \(or no\) rows returned/i.test(message)
        || /json object requested/i.test(message)
        || /no rows returned/i.test(message)
        || /permission denied/i.test(message)
    );
}

export function toPrivateOrNotFoundError(error: unknown): Error | null {
    if (!isPrivateOrNotFoundError(error)) {
        return null;
    }

    return new Error(PRIVATE_OR_NOT_FOUND);
}
